import React from "react";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

export function ServiceCatalogDialog({ open, onOpenChange, services, onAddService }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[80vh] max-w-3xl overflow-y-auto border-[#242E42] bg-[#151B26] text-[#F3F4F6]">
        <DialogHeader>
          <DialogTitle className="text-[#E2B05E]">
            Seleccionar del Catálogo
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-3">
          {services.length === 0 ? (
            <div className="py-8 text-center text-[#9CA3AF]">
              No hay servicios disponibles en el catálogo
            </div>
          ) : (
            <div className="grid gap-3">
              {services.map((service) => (
                <div
                  key={service.service_id}
                  role="button"
                  tabIndex={0}
                  className="cursor-pointer rounded-lg border border-[#242E42] bg-[#0B0E14] p-4 text-left transition-colors hover:border-[#E2B05E]"
                  onClick={() => onAddService(service)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      onAddService(service);
                    }
                  }}
                >
                  <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                    <div className="min-w-0 flex-1">
                      <div className="mb-1 flex flex-wrap items-center gap-2">
                        <h4 className="font-semibold text-[#F3F4F6]">
                          {service.name}
                        </h4>
                        {service.category && (
                          <Badge className="bg-[#3AB8D6]/20 text-xs text-[#3AB8D6]">
                            {service.category}
                          </Badge>
                        )}
                      </div>
                      {service.description && (
                        <p className="mb-2 text-sm text-[#9CA3AF]">
                          {service.description}
                        </p>
                      )}
                      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
                        <span className="text-[#9CA3AF]">
                          Unidad: {service.unit}
                        </span>
                        <span className="font-semibold text-[#E2B05E]">
                          Precio: ${service.sale_price?.toFixed(2)}
                        </span>
                      </div>
                    </div>
                    <Button
                      type="button"
                      size="sm"
                      className="w-full bg-[#E2B05E] text-[#0B0E14] hover:bg-[#F0C47A] sm:w-auto"
                      onClick={(event) => {
                        event.stopPropagation();
                        onAddService(service);
                      }}
                    >
                      Agregar
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default ServiceCatalogDialog;
